import { render, staticRenderFns } from "./PasswordReseted.vue?vue&type=template&id=532ee7b6&scoped=true&"
import script from "./PasswordReseted.vue?vue&type=script&lang=js&"
export * from "./PasswordReseted.vue?vue&type=script&lang=js&"
import style0 from "./PasswordReseted.vue?vue&type=style&index=0&id=532ee7b6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532ee7b6",
  null
  
)

export default component.exports